import React, { useState, useEffect } from 'react';
import OwlCarousel from 'react-owl-carousel';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from '../config';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Latest = () => {
    const [latestNews, setLatestNews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLatestNews = async () => {
            try {
                const response = await axios.get(`${API_URL}api/index`);
                if (response.data && response.data.status === "success" && Array.isArray(response.data.data)) {
                    const sortedNews = response.data.data
                        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                        .slice(0, 8);
                    setLatestNews(sortedNews);
                } else {
                    console.error('Unexpected data structure:', response.data);
                }
            } catch (error) {
                console.error('Error fetching latest news:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchLatestNews();
    }, []);

    const options = {
        loop: true,
        margin: 10,
        nav: true,
        dots: false,  // Hide dots
        autoplay: true,
        autoplayTimeout: 3000,
        navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 4,
            },
        },
    };

    const truncateDescription = (description, wordCount = 10) => {
        const words = description.split(' ');
        return words.length > wordCount ? words.slice(0, wordCount).join(' ') + '...' : description;
    };

    if (loading) {
        return <div></div>;
    }

    return (
        <div className="container-fluid latest-news py-3">
            <div className="container">
                <h2 className="mb-4"
                    style={{
                        color: '#000',
                        fontFamily: 'Noto Sans, sans-serif',
                        font: "400 27px/ 21px 'Noto Sans', sans-serif",
                    }}
                >Latest News</h2>
                <OwlCarousel className="owl-theme" {...options}>
                    {latestNews.map((news) => (
                        <div key={news.id} className="latest-news-item">
                            <div className="bg-light rounded">
                                <div className="rounded-top overflow-hidden">
                                    <img
                                        src={`${API_URL}${news.image}`}
                                        className="img-zoomin img-fluid rounded-top w-100"
                                        alt={news.cetegorieName}
                                        style={{ height: '200px' }}
                                    />
                                </div>
                                <div className="d-flex flex-column p-2">
                                    <Link to={`/${news.id}`} className="h4"
                                        style={{
                                            color: '#333',
                                            fontFamily: 'Noto Sans, sans-serif',
                                            font: "400 20px/ 21px 'Noto Sans', sans-serif",
                                            height: '45px',
                                        }}
                                        onClick={() => {
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                        }}
                                    >
                                        {truncateDescription(news.short_description || news.description)}
                                    </Link>

                                    <div className="d-flex justify-content-between">
                                        <span className="small"
                                            style={{
                                                color: '#000',
                                                fontFamily: 'Noto Sans, sans-serif',
                                                font: "400 15px/ 21px 'Noto Sans', sans-serif",
                                            }}
                                        >
                                            {news.cetegorieName}
                                        </span>
                                        <small className="d-block"
                                            style={{
                                                color: '#000',
                                                fontFamily: 'Noto Sans, sans-serif',
                                                font: "400 15px/ 21px 'Noto Sans', sans-serif",
                                            }}
                                        >
                                            <i className="fas fa-calendar-alt me-1"></i>
                                            {new Date(news.created_at).toLocaleDateString('en-IN', {
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric'
                                            })}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </OwlCarousel>
            </div>
        </div>
    );
};

export default Latest;